<template>
    <aside class="c-search-page__tips">
        <div class="c-tips">
            <div class="c-tips__head">
                <h2 class="c-tips__title">
                    <span class="fal fa-lightbulb-on" aria-hidden="true"></span>
                    Search tip:
                </h2>
            </div>
            <div class="c-tips__content">
                <div class="c-content">
                    <p>
                        Put your search phrase in quotes to get an exact match. For example,
                        <a href="https://www.folger.edu/search/?area=works&q=%22to%20be%20or%20not%20to%20be%22">
                            "to&nbsp;be or not to&nbsp;be"
                        </a>.
                    </p>
                </div>
                <a class="c-link" href="https://www.folger.edu/shakespeares-works-search-tips">
                    View more tips
                </a>
            </div>
        </div>
    </aside>
</template>

<script>
    export default {
        name: "Tips"
    }
</script>

<style scoped>

</style>
